// AUTO-GENERATED — do not edit. Run `npm run tokens` to update.
// Source: design-tokens.json

export const CHART_SERIES: readonly string[] = [
  '#16A085',
  '#65DABC',
  'oklch(72.33% 0.1430 40.11)',
  'oklch(52.53% 0.1354 219.94)',
  'oklch(86.137% 0.01232 255.14)',
  'oklch(63.518% 0.06503 164.90)',
  'oklch(64.639% 0.22007 16.45)',
  '#2F7ED8',
  '#C43C8E',
  '#E0A21E',
  'oklch(79.33% 0.0739 237.54)',
  'oklch(37.2% 0.044 257.287)',
];

export const CHART_SERIES_NEUTRAL = '#757779';
